'use client';
import Security from './_components';

const Content = (): JSX.Element => {
  return <Security />;
};

export default Content;
